import React from "react";
import PropTypes from 'prop-types';

export default class Burger extends React.PureComponent {
    render() {
        let { onClick, isWhite } = this.props;

        return (
            <div className={'burger'}>
                <img alt={'menu'} onClick={onClick} src={isWhite ? require('../../assets/images/icons/burger-white.svg') : require('../../assets/images/icons/burger.svg')}/>
            </div>
        );
    }
}

Burger.propTypes = {
    onClick: PropTypes.func.isRequired,
    isWhite: PropTypes.bool.isRequired,
    className: PropTypes.string,
};
